import React from "react";
import { CheckCircle } from "lucide-react";
import "./style.css";
import { Helmet } from "react-helmet-async";

const About = () => {
	const offers = [
		{
			title: "Custom ReactJS Development",
			text: "Building tailored solutions that match your business requirements perfectly",
			colorClass: "offer-color-primary",
		},
		{
			title: "Seamless Hosting",
			text: "Reliable deployment and hosting solutions for optimal performance",
			colorClass: "offer-color-nebula",
		},
		{
			title: "Ongoing Support",
			text: "Dedicated maintenance and support to keep your application running smoothly",
			colorClass: "offer-color-plasma",
		},
		{
			title: "Performance Optimization",
			text: "Ensuring your web applications are fast, efficient, and user-friendly",
			colorClass: "offer-color-aurora",
		},
	];

	return (
		<section id="about" className="about-section">
            <Helmet>
				<title>Moonface Techs | About</title>
				<meta name="description" content="Moonface Techs - Learn more about our company and services" />
			</Helmet>
			<div className="about-container">
				<p className="rule-mono">
					About <span className="rule-line" />
				</p>

				<div className="about-grid">
					<div>
						<h2 className="about-title">
							Our <span className="title-gradient">Story</span>
						</h2>
						<p className="about-text">
							At Moonface Techs, we are passionate about creating high-quality
							web solutions that help businesses thrive in the digital world.
							Our team specializes in ReactJS development, delivering modern,
							responsive, and scalable applications tailored to meet your unique
							needs.
						</p>
						<p className="about-text-secondary">
							We believe in the power of clean code, intuitive design, and
							seamless user experiences. Whether you're a startup looking to
							establish your online presence or an established business seeking
							to modernize your digital infrastructure, we're here to help you
							succeed.
						</p>

						<div className="built-on-card">
							<span className="card-top-line" />
							<p className="card-label">Built on</p>
							<p className="card-techs">
								React · TypeScript · Firebase Tools · Modern hosting
							</p>
						</div>
					</div>

					<div className="offers-card">
						<h3 className="offers-title">What We Offer</h3>
						<ul className="offers-list">
							{offers.map((offer) => (
								<li key={offer.title} className="offer-item">
									<CheckCircle className={`offer-icon ${offer.colorClass}`} />
									<div>
										<strong className="offer-item-title">{offer.title}</strong>
										<p className="offer-item-text">{offer.text}</p>
									</div>
								</li>
							))}
						</ul>
					</div>
				</div>
			</div>
		</section>
	);
};

export default About;
